var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded p-1 relative classSign m-1 pb-3 flex-shrink-0 flex items-center justify-center",staticStyle:{"background-color":"transparent"}})
}
var staticRenderFns = []

export { render, staticRenderFns }